var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"image",class:{ is_ipad: _vm.isIPad }},[_c('img',{attrs:{"src":_vm.imgPath}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }